import DashboardNavbarContainer from './DashboardNavbar.container';

export default DashboardNavbarContainer;
